import React from "react";
import LandingLayout from "./LandingLayout";
import { MdTimeline, MdVerified } from "react-icons/md";

const LandingQuienesSomos = () => {
    return (
        <LandingLayout>
            <div className="bg-gray-50 py-16 lg:py-24">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="text-center mb-16">
                        <h1 className="text-4xl font-extrabold text-gray-900 sm:text-5xl">Quiénes Somos</h1>
                        <p className="mt-4 text-xl text-gray-500 max-w-2xl mx-auto">Nuestra historia, misión y visión.</p>
                    </div>

                    <div className="grid lg:grid-cols-2 gap-12 items-center">
                        <div className="prose prose-lg text-gray-600">
                            <p className="leading-relaxed">
                                Atecma es una empresa de <strong>Asesorías Técnicas y Mantención Ltda.</strong> Nace en el año 2004, en sus comienzos
                                solamente tuvo la intención de una independización laboral.
                            </p>
                            <p className="leading-relaxed mt-4">
                                No obstante, hoy luego de más de <strong>15 años de haber emprendido el vuelo</strong>, podemos decir que hemos logrado
                                consolidarnos como una empresa confiable y altamente solicitada en el rubro, brindando soluciones integrales
                                a nuestros clientes.
                            </p>
                            <p className="leading-relaxed mt-4">
                                Nuestra filosofía se basa en el compromiso, la precisión técnica y la seguridad operable, valores que nos han
                                permitido mantener relaciones duraderas con los principales actores del mercado energético.
                            </p>
                        </div>
                        <div className="space-y-6">
                            <div className="bg-white p-8 rounded-2xl shadow-lg border-l-4 border-amber-500">
                                <h4 className="text-2xl font-bold text-gray-900 mb-4 flex items-center gap-3">
                                    <div className="p-2 bg-amber-100 rounded-lg text-amber-600"><MdTimeline size={24} /></div>
                                    Misión
                                </h4>
                                <p className="text-gray-600 leading-relaxed">Entregar un servicio de calidad superior en mantención y calibración, garantizando la continuidad operativa y exactitud para nuestros clientes, contribuyendo así al desarrollo eficiente de la industria.</p>
                            </div>
                            <div className="bg-white p-8 rounded-2xl shadow-lg border-l-4 border-gray-800">
                                <h4 className="text-2xl font-bold text-gray-900 mb-4 flex items-center gap-3">
                                    <div className="p-2 bg-gray-100 rounded-lg text-gray-800"><MdVerified size={24} /></div>
                                    Visión
                                </h4>
                                <p className="text-gray-600 leading-relaxed">Ser reconocidos a nivel nacional como el socio estratégico más confiable e innovador en la industria de hidrocarburos, estableciendo estándares de excelencia en cada proyecto.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </LandingLayout>
    );
};

export default LandingQuienesSomos;
